import { epic$, store } from '@redux/store';
import fetchUtmParameters from './redux/epics';
import utmParametersSlice from './redux/slices';
import { isLoading, selectUtmTrackingCommonProperties } from './redux/selectors';


const { actions, reducer } = utmParametersSlice;

epic$.next(fetchUtmParameters);
store.injectReducer('utmParameters', reducer);

export {
  fetchUtmParameters,
  isLoading,
  actions as utmParametersActions,
  reducer as utmParametersReducers,
  selectUtmTrackingCommonProperties,
};
